import useAuthStore from "@/stores/useAuthStore";
import { FeatureFlags } from "@shared/lib/database/jsonb.types";
import { storeToRefs } from "pinia";
import { computed } from "vue";

export default function (flag: keyof FeatureFlags) {
  const {
    currentPlayer,
  } = storeToRefs(useAuthStore());

  return computed(() => {
    const featureFlags = currentPlayer.value?.feature_flags as unknown as FeatureFlags;

    return featureFlags[flag];
  });
}
